export default __webpack_public_path__ + "static/media/SD-srisaila-tv-bg.da9b2dc1.png";